import { render, staticRenderFns } from "./PhoneNumberInput.vue?vue&type=template&id=5900b618&scoped=true&"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=ts&"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneNumberInput.vue?vue&type=style&index=0&id=5900b618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5900b618",
  null
  
)

export default component.exports